import { useTranslation } from 'react-i18next';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Field } from '~/components/promotion/editor-section';
import { TierFields } from './tier-fields';
import type { PromotionAction } from '~/lib/schemas/actions';

type Action = Extract<PromotionAction, { type: 'percentage-discount' }>;

interface Props {
	value: Action;
	onChange: (next: Action) => void;
}

export function PercentageDiscountBody({ value, onChange }: Props) {
	const { t } = useTranslation();
	return (
		<div className="flex flex-col gap-4">
			<TierFields value={value} onChange={tf => onChange({ ...value, ...tf })} valueLabel="percent" />
			<Field label={t('promotion.action.applyOnDiscounted.label')} help={t('promotion.action.applyOnDiscounted.help')}>
				<Select
					value={value.applyOnDiscountedProducts}
					onValueChange={v => onChange({ ...value, applyOnDiscountedProducts: v as Action['applyOnDiscountedProducts'] })}>
					<SelectTrigger>
						<SelectValue />
					</SelectTrigger>
					<SelectContent>
						<SelectItem value="none">{t('promotion.action.applyOnDiscounted.none')}</SelectItem>
						<SelectItem value="max">{t('promotion.action.applyOnDiscounted.max')}</SelectItem>
						<SelectItem value="additive">{t('promotion.action.applyOnDiscounted.additive')}</SelectItem>
						<SelectItem value="onFinal">{t('promotion.action.applyOnDiscounted.onFinal')}</SelectItem>
					</SelectContent>
				</Select>
			</Field>
		</div>
	);
}
